export default class FormattedInputService {

    formatPhoneNumber = (value: string) => {
        if (!value){
            return value;
        }
        
        // Remove all non-numeric characters
        const numericValue = value.replace(/\D/g, "");
    
        // Format the number as xxx-xxx-xxxx
        if (numericValue.length <= 3) {
          return numericValue;
        } else if (numericValue.length <= 6) {
          return `${numericValue.slice(0, 3)}-${numericValue.slice(3)}`;
        } else {
          return `${numericValue.slice(0, 3)}-${numericValue.slice(
            3,
            6
          )}-${numericValue.slice(6, 10)}`;
        }
    };

    getRawPhoneNumber = (formattedValue : string) => {
      return formattedValue?.replaceAll('-','');
    }
    formatZipCode = (value: string): string => {
        if (!value) return value;
        const numericValue = value.replace(/\D/g, '');
        if (numericValue.length <= 5) return numericValue;
        return `${numericValue.slice(0, 5)}-${numericValue.slice(5, 9)}`;
    };

    getRawZipCode = (formattedValue: string): string => {
        return formattedValue?.replace(/[^0-9]/g, '').trim() ?? '';
    };

};